module.exports = __webpack_public_path__ + "img/banner-personal-accident.77dd5097.png";